import gql from 'graphql-tag';

export const searchResultTypeFacetFragment = gql`
  fragment searchResultTypeFacetFragment on SearchResultTypeFacet {
    dokkioClass
    count
    searchResultType
  }
`;
export default searchResultTypeFacetFragment;
